<template>
  <div class="plv-ia-checkin-history">
    <div class="plv-ia-checkin-history__body">
      <div class="plv-ia-checkin-history__scroll">
        <div class="plv-ia-checkin-history-filters">
          <span>{{ t('plvIA.checkIn.timeRange') }}</span>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            range-separator="~"
            :start-placeholder="t('plvIA.datePicker.startTime')"
            :end-placeholder="t('plvIA.datePicker.endTime')"
            :popper-class="'plv-ia-checkin-date-picker'"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            align="center"
            :picker-options="pickerOptions"
            @change="dateChange"
          />
          <button class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue" @click="handleSearch">{{ t('plvIA.checkIn.search') }}</button>
          <span
            v-if="right.download"
            class="plv-ia-btn-text pws-vclass-btn-text"
            @click="downloadHistory"
          >{{ t('plvIA.checkIn.downloadRecords') }}</span>
        </div>
        <div class="plv-ia-checkin-history-list">
          <div class="plv-ia-checkin-history-list__header">
            <div class="plv-ia-checkin-history-list__row">
              <span>{{ t('plvIA.checkIn.checkedInTime') }}</span>
              <span>{{ t('plvIA.checkIn.checkedInNum') }}</span>
              <span>{{ t('plvIA.checkIn.checkedInRate') }}</span>
              <span>{{ t('plvIA.checkIn.operation') }}</span>
            </div>
          </div>
          <div class="plv-ia-checkin-history-list__body">
            <template v-if="hisListData.length > 0">
              <div v-for="item in hisListData" :key="item.checkInId" class="plv-ia-checkin-history-list__row">
                <span>{{ item.checkInTime }}</span>
                <span>{{ item.checkInNum }}{{ t('plvIA.checkIn.person') }}</span>
                <span>{{ calculatePercent(item.checkInNum, item.onlineNum) }}</span>
                <span class="plv-ia-btn-text pws-vclass-btn-text" @click="showDetail(item.checkInId)">{{ t('plvIA.checkIn.detail') }}</span>
              </div>
            </template>
            <div v-else class="plv-ia-checkin-history-list__row">
              <p>{{ (startTime && endTime) ? t('plvIA.checkIn.noData') : t('plvIA.checkIn.enterTimeRange') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="plv-ia-checkin-history__footer">
      <button class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue" @click="hide">{{ t('plvIA.checkIn.return') }}</button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { calculatePercent } from './helper';

export default {
  mixins: [Locale],
  props: {
    mainData: {
      type: Array,
      default() {
        return [];
      },
    },
    right: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      startTime: null,
      endTime: null,
      dateValue: [],
      startConfig: {
        dateFormat: 'Y-m-d',
        minDate: null,
        maxDate: new Date().getTime()
      },
      endConfig: {
        dateFormat: 'Y-m-d',
        minDate: null,
        maxDate: new Date().getTime()
      },
      hisListData: [], // 历史签到记录列表
      singleData: [],
      visible: false,
      pickerOptions: {
        disabledDate: time => {
          return time > this.getMaxTimes();
        }
      }
    };
  },

  watch: {
    mainData(val) {
      this.hisListData = val.concat().reverse();
    }
  },
  created() {
    this.initData();
  },

  methods: {
    calculatePercent,

    initData() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const date = now.getDate();
      this.defaultStartTime = month === 0 ? `${year - 1}-12-${date}` : year + '-' + month + '-' + date;
      this.defaultEndTime = year + '-' + (month + 1) + '-' + date;

      this.dateValue = [this.defaultStartTime, this.defaultEndTime];
      this.startTime = this.dateToTimeStamp(this.defaultStartTime);
      this.endTime = this.dateToTimeStamp(this.defaultEndTime) + 86399059; // 23, 59, 59, 59
    },

    // 获取当前时间
    getMinTimes(value) {
      let secondTime = parseInt(value); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 小时
      if (secondTime > 60) {
        // 如果秒数大于60，将秒数转换成整数
        // 获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        // 获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        // 如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          // 获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          // 获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      let result = '' + parseInt(secondTime) + this.t('plvIA.checkIn.seconds');

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + this.t('plvIA.checkIn.minutes') + result;
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + this.t('plvIA.checkIn.hours') + result;
      }
      return result;
    },
    getMaxTimes() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const date = now.getDate();
      return new Date(year, month, date, 23, 59, 59, 59).getTime();
    },

    getYmd(date) {
      const now = new Date();
      return `${now.getFullYear()}-${now.getMonth() + date}-${now.getDate()}`;
    },

    dateToTimeStamp(date) {
      date = date.replace(/-/g, '/');
      return new Date(date).getTime();
    },

    dateChange(time) {
      if (time) {
        this.startTime = this.dateToTimeStamp(time[0]);
        this.endTime = this.dateToTimeStamp(time[1]);
      }
    },

    showDetail(checkInId) {
      this.$emit('show-detail', checkInId);
    },

    getDateRange() {
      if (!this.dateValue) return;

      const startDate = this.dateValue[0];
      const endDate = this.dateValue[1];
      return {
        startDate,
        endDate
      };
    },

    handleSearch() {
      const option = this.getDateRange();
      if (!option) return;
      this.$emit('show-history', option);
    },

    hide() {
      this.$emit('close');
      this.initData();
    },

    downloadHistory() {
      const option = this.getDateRange();
      if (!option) return;
      this.$emit('download-history', option);
    },
  }
};
</script>

<style lang="scss">
.plv-ia-checkin-history {
  height: 100%;
  position: relative;
}

.plv-ia-checkin-history__body {
  padding-bottom: 70px;
  height: 100%;
  box-sizing: border-box;
}

.plv-ia-checkin-history__footer {
  position: absolute;
  width: 100%;
  height: 70px;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  text-align: center;
  padding-top: 24px;
}

.plv-ia-checkin-history__scroll {
  height: 100%;
  overflow: auto;
  padding: 14px 16px;
  box-sizing: border-box;
}

.plv-ia-checkin-history-filters {
  width: 100%;
  margin-bottom: 14px;
  box-sizing: border-box;
  color: #333;
  font-size: 0;

  >* {
    font-size: 14px;
    margin-right: 8px;
  }

  >div {
    display: inline-block;
  }

  button {
    width: 64px;
  }

  .plv-ia-btn-text {
    float: right;
    text-decoration: none;
    line-height: 32px;
    margin: 0;
  }

  .el-date-editor .el-range__icon {
    display: none;
  }
  .el-range-editor.el-input__inner {
    padding: 0;
    height: 32px;
    width: 220px;
    box-sizing: border-box;
  }
  .el-range-editor .el-range-input {
    background: transparent;
    width: 50%;
  }
  .el-range-separator {
    padding: 0;
  }
}

.plv-ia-checkin-history-list__header {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: #EDF1F7;
  border-bottom: 1px solid #CFD8DC;
}

.plv-ia-checkin-history-list__body {

  .plv-ia-checkin-history-list__row {
    &:nth-child(odd) {
      background: #fff;
    }
    &:nth-child(even) {
      background: #F8F8FB;
    }
  }
}

.plv-ia-checkin-history-list__row {
  font-size: 0;
  height: 46px;
  line-height: 46px;

  >* {
    font-size: 14px;
    text-align: center;
  }

  p {
    color: #757575;
  }

  span {
    display: inline-block;
    width: 20%;

    &:first-child {
      width: 40%;
    }
  }
}

.plv-ia-checkin-date-picker {
  width: 500px;

  .el-picker-panel__content {
    width: 250px;
  }

  .el-date-table td {
    padding: 0;
  }

  .el-date-table td.disabled div {
    background: transparent;
    color: rgba(#000, 0.25);
  }

  .el-date-table td span {
    border-radius: 2px;
  }

  .el-date-table td.current:not(.disabled) span {
    background: #2196F3;
    color: #fff;
  }

  .plv-ia-qa-filter-date-choosed span {
    background: #E6F7FF;
    border-radius: 2px;
  }

  .el-date-table td.today:not span {
    border: 1px solid rgba(#2196F3, 0.8);
    color: rgba(#2196F3, 0.8);
    box-sizing: border-box;
  }

  .el-date-table td.today.end-date span,
  .el-date-table td.today.start-date span {
    color: #fff;
  }

  .el-date-table td div {
    padding: 0;
    height: 24px;
  }

  .el-date-range-picker__content {
    padding: 8px;
  }
}
</style>
